import React, { memo } from 'react'
import tw from 'twin.macro'
import { CirclePlusMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { colors } from 'src/theme'
import { InviteTeamMemberModal } from './InviteTeamMemberModal'
import { TeamTableTab } from 'src/constants/team/enums'
import { useModalOpen } from 'src/hooks/useModalOpen'

interface Props {
  setSelectedTab: (tab: TeamTableTab) => void
  onRefreshTeamMemberInvites: () => void
}

const InviteTeamMemberButtonComponent = ({ setSelectedTab, onRefreshTeamMemberInvites }: Props) => {
  const {
    isOpen: isInviteTeamMemberOpen,
    open: openInviteTeamMember,
    close: closeInviteTeamMember,
  } = useModalOpen()

  return (
    <>
      <Button
        css={tw`mr-2`}
        color="dark"
        size="small"
        leftIcon={<CirclePlusMinor fill={colors.BASICS_WHITE} width={20} />}
        onClick={openInviteTeamMember}
      >
        Invite user
      </Button>
      <InviteTeamMemberModal
        isInviteTeamMemberOpen={isInviteTeamMemberOpen}
        closeInviteTeamMember={closeInviteTeamMember}
        setSelectedTab={setSelectedTab}
        onRefreshTeamMemberInvites={onRefreshTeamMemberInvites}
      />
    </>
  )
}

export const InviteTeamMemberButton = memo(InviteTeamMemberButtonComponent)
